<template>
    <span v-if="mensagem.status == 0">
        <b-button
            variant="primary"
            @click.stop="confirmarSalvar()"
            class="float-right ml-2"
            :disabled="desabilitarSalvar"
        >
            <span> <i class="fa fa-floppy-o"></i> Salvar </span>
        </b-button>
    </span>
</template>

<script>
import MensagensServicos from './MensagensServicos'

export default {
    props: {
        mensagem: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarSalvar() {
            this.$swal({
                title: 'Salvar Mensagem',
                html: `Confirma o armazenamento da mensagem como rascunho?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let mensagemDto = {
                assunto: this.mensagem.assunto,
                conteudo: this.mensagem.conteudo
            }
            if (this.mensagem.mensagemId) {
                mensagemDto.mensagemId = this.mensagem.mensagemId
            }
            if (!this.$store.getters.isFornecedor) {
                mensagemDto.destinatarios = this.mensagem.destinatarios
            }
            MensagensServicos.salvarMensagem(mensagemDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Mensagem salva com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterMensagensAtualizadas')
                        this.$router.push({
                            name: 'Mensagens_Detalhar',
                            params: {
                                mensagemId: response.data
                            }
                        })
                    } else {
                        this.$toast.error(
                            'Erro ao salvar mensagem!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        desabilitarSalvar() {
            if (
                this.mensagem.assunto.length > 0 &&
                this.mensagem.conteudo.length > 0
            )
                return false
            return true
        }
    },

    watch: {},

    validations: {}
}
</script>
